export default __webpack_public_path__ + "beta-maps-guides-streets-960-d7b3ed26bcd9e2d66b7dd35cb7e2293e.webp";